import React from 'react';
import { Button, Typography } from '@mui/material';
import { SOUCHES } from 'Components/ControleOrders/constants';
import { DEPOSITS_O } from 'Shared/constants/order';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';

export const formatUserName = (user) => (user
  ? `${user.firstName} ${user.lastName}` : '');

export const Fields = [
  { name: 'reference', label: 'Numéro de pièce', disabled: true },
  {
    name: 'souche', label: 'SOUCHE', type: 'select', options: SOUCHES,
  },
  { name: 'date', label: 'DATE', type: 'date' },
  {
    name: 'expedition',
    label: 'EXPÉDITION',
    type: 'select',
  },
  { name: 'numExpedition', label: 'NUMÉRO D’EXPÉDITION' }, //*
  {
    name: 'repo', label: 'DÉPÔT', type: 'select', options: DEPOSITS_O,
  },
  { name: 'paymentMode', label: 'CONDITIONS DE LIVRAISON', type: 'select' },
  { name: 'colisage', label: 'NOMBRE DE COLIS', type: 'number' },
  { name: 'totalWeight', label: 'POIDS', type: 'number' }, // new
  {
    name: 'saler',
    label: 'REPRÉSENTANT',
    type: 'select',
    getOptionLabel: (option) => option.name,
    filterOptions: (ops, v) => ops
      .filter((o) => !v.inputValue
      || o.name?.toLowerCase().includes(v.inputValue.toLowerCase())),
  },
  {
    name: 'client',
    label: 'CLIENT',
    type: 'select',
    getOptionLabel: (option) => `${option.code} : ${option.name}`,
    filterOptions: (options, v) => options.filter(
      (option) => option.name?.toLowerCase().includes(v.inputValue.toLowerCase())
            || option.code?.toLowerCase().includes(v.inputValue.toLowerCase()),
    ),
  },
  /* {
    name: 'controlledBy',
    label: 'CONTRÔLÉ PAR',
    type: 'select',
    hasFetchApi: true,
    getOptionLabel: (option) => `${option.firstName} ${option.lastName}`,
    filterOptions: (ops, v) => ops
      .filter((o) => !v.inputValue
      || o.firstName?.toLowerCase().includes(v.inputValue.toLowerCase())
      || o.lastName?.toLowerCase().includes(v.inputValue.toLowerCase())),
  }, */
  {
    name: 'biller',
    label: 'FACTURÉ PAR',
    type: 'select',
    getOptionLabel: (option) => option.userName,
    filterOptions: (ops, v) => ops
      .filter((o) => !v.inputValue
      || o.userName?.toLowerCase().includes(v.inputValue.toLowerCase())),
  },
  {
    name: 'picker',
    label: 'PIQUÉ PAR',
    type: 'select',
    getOptionLabel: (option) => option.userName,
    filterOptions: (ops, v) => ops
      .filter((o) => !v.inputValue
      || o.userName?.toLowerCase().includes(v.inputValue.toLowerCase())),
  },
  {
    name: 'packedBy',
    label: 'EMBALLÉ PAR', // not found
    type: 'select',
    getOptionLabel: (option) => option.userName,
    filterOptions: (ops, v) => ops
      .filter((o) => !v.inputValue
      || o.userName?.toLowerCase().includes(v.inputValue.toLowerCase())),
  },
];

export const INIT_DOC = {
  reference: '', expedition: null, souche: null, paymentMode: null, type: null, products: [],
};

export const TitleStyle = {
  fontSize: '12px',
  fontWeight: 500,
  borderBottom: 'none',
  textTransform: 'uppercase',
  background: '#e4e7ea',
  font: 'normal normal 600 10px Montserrat',
  letterSpacing: 0,
  color: '#707070',
  padding: '12px 3px',
};
export const defaultColumnStyle = {
  font: 'normal normal 600 12px Montserrat',
  letterSpacing: 0,
  color: '#38485C',
  display: 'block',
};

export const columns = (onEditLine, onRemoveLine) => [
  {
    id: 'product',
    label: 'RÉFÉRENCE',
    style: {
      ...TitleStyle,
      zIndex: 900,
    },
    render: ({ value }) => (
      <Typography style={{ ...defaultColumnStyle, mr: '9px', fontWeight: 'bold' }} display="inline">
        {value?.reference}
      </Typography>
    ),
  },
  {
    id: 'productName',
    label: 'DÉSIGNATION',
    style: {
      ...TitleStyle,
      zIndex: 900,
    },
    render: ({ value }) => (
      <Typography style={{ ...defaultColumnStyle, mr: '9px', fontWeight: 'bold' }} display="inline">
        {value}
      </Typography>
    ),
  },
  {
    id: 'quantity',
    label: 'QTÉ',
    style: {
      ...TitleStyle,
      zIndex: 900,
    },
    render: ({ value }) => (
      <Typography style={{ ...defaultColumnStyle, mr: '9px', fontWeight: 'bold' }} display="inline">
        {value}
      </Typography>
    ),
  },
  {
    id: 'remise',
    label: 'REMISE',
    style: {
      ...TitleStyle,
      zIndex: 900,
    },
    render: ({ value }) => (
      <Typography style={{ ...defaultColumnStyle, mr: '9px', fontWeight: 'bold' }} display="inline">
        {`${value}%`}
      </Typography>
    ),
  },
  {
    id: 'amountTtc',
    label: 'MONTANT TTC',
    style: {
      ...TitleStyle,
      zIndex: 900,
    },
    render: ({ value }) => (
      <Typography style={{ ...defaultColumnStyle, mr: '9px', fontWeight: 'bold' }} display="inline">
        {`${value} DH`}
      </Typography>
    ),
  },
  {
    id: 'action',
    label: '',
    style: {
      ...TitleStyle,
      zIndex: 900,
    },
    render: ({ row }) => (
      <>
        <Button
          size="small"
          onClick={() => onRemoveLine(row.product.reference)}
          style={{
            width: '30px',
            minWidth: '30px',
            height: '30px',
            backgroundColor: '#FFFFFF',
            borderRadius: '12px',
          }}
        >
          <DeleteOutlineIcon style={{ heught: '15px', width: 'auto', color: '#F86060' }} />
        </Button>
        <Button
          size="small"
          onClick={() => onEditLine(null, row)}
          style={{
            marginLeft: '5px',
            width: '30px',
            minWidth: '30px',
            height: '30px',
            backgroundColor: '#FFFFFF',
            borderRadius: '12px',
          }}
        >
          <EditIcon style={{ heught: '15px', width: 'auto' }} />
        </Button>
      </>
    ),
  },
];

// Check if each product object has no null or empty values for the specified attributes
export const validateProducts = (docProducts) => docProducts
  .every((product) => product.productRef
  && product.productName
  && product.amountTtc
  && !Number.isNaN(product.amountTtc) // Check if amountTtc is a valid number
  && product.quantity
  && !Number.isNaN(product.quantity)
  && product.price
  && !Number.isNaN(product.price));

export const validateBodyDocVente = (bodyDocVente) => {
  const requiredFields = [
    // { key: 'colisage', label: 'Colisage' },
    { key: 'date', label: 'DATE' },
    { key: 'reference', label: 'Numéro de pièce' },
    { key: 'clientId', label: 'CLIENT' },
    { key: 'expedition', label: 'EXPÉDITION' },
    { key: 'paymentMode', label: 'CONDITIONS DE LIVRAISON' },
    { key: 'commercialId', label: 'REPRÉSENTANT' },
    { key: 'repoId', label: 'DÉPÔT' },
    { key: 'souche', label: 'SOUCHE' },
    // { key: 'totalWeight', label: 'poid' },
    { key: 'type', label: 'type' },
    // { key: 'numExpedition', label: 'num d expediton' },
    // { key: 'biller', label: 'facturé par' },
    // { key: 'packedBy', label: 'embalé par' },
    // { key: 'picker', label: 'piqué par' },
    { key: 'paymentMode', label: 'Mode de payment' },
  ];
  const invalidField = requiredFields
    .find((field) => !(bodyDocVente[field.key] || bodyDocVente[field.key] === 0));

  if (invalidField) {
    throw new Error(`Le champ "${invalidField.label}" est obligatoire. Veuillez le remplir avant d’enregistrer le document.`);
  }

  return true; // If all fields are valid
};
